import { render, staticRenderFns } from "./index.vue?vue&type=template&id=edc0ca84&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=edc0ca84&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc0ca84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edc0ca84')) {
      api.createRecord('edc0ca84', component.options)
    } else {
      api.reload('edc0ca84', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=edc0ca84&scoped=true&lang=pug", function () {
      api.rerender('edc0ca84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dojo/bookClass/requireConsultant/schedule/index.vue"
export default component.exports